<template>
  <div class="fwwd">
    <el-card v-for="(item,index) in address" :key="index">
      <p class="lineWord">
        <img src="../../../static/icon/landian.svg" width="12" height="12">
        <span>{{item.Address}}</span><el-button style="float: right;padding:0" @click.native="adres(item)" type="text"><img src="../../../static/icon/weizhi.svg" width="20" height="20"></el-button>
      </p >
      <p class="lineWord">
        <span style="color: #979797">工作地址：</span>{{item.gzdz}}
      </p>
      <p class="lineWord">
        <span style="color: #979797">受理业务：</span>{{item.slyw}}
      </p>
     <p class="lineWord" v-if="item.cclx.length">
       <span style="color: #979797">联系方式：</span>
       <a class="text_blue" v-for="items in item.cclx" :href="'tel:'+items.tel"><span v-if="items.label">（{{items.label}}）</span>{{items.tel}} </a>
     </p>
    </el-card>
  </div>
</template>

<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>

  import {getQueryVariable, weixinInit} from "@/utils";

export default {
  name: "fuwuwangdian",
  data () {
    return {
      address:[
        {
          Address:'公司业务、收费大厅',
          gzdz:'甘肃省庆阳市西峰区北地西路庆化实验学校西侧约260米。',
          cclx:[
            {
              tel: '0934-8610311',
              label: '业务受理'
            },
            {
              tel: '0934-8610313',
              label: '收费'
            }
          ],
          wz: [35.700519,107.636175],
          slyw: '入网开户、锁闭报停、锁闭复供、面积变更、更名过户、供热缴费、电子发票、政策咨询'
        },
        {
          Address:'北区客户服务中心',
          gzdz:'甘肃省庆阳市西峰区交校巷与解放西路交叉路口往东北约60米，凤凰圣境物业院内（原凤凰圣境客服中心）',
          cclx:[
            {
              tel: '0934-8610317'
            }
          ],
          slyw: '入网开户、锁闭报停、锁闭复供、面积变更、更名过户、刷卡及扫码缴费（不受理现金缴费）、电子发票、政策咨询',
          wz: [35.741368,107.637266]
        },
        {
          Address:'东区客户服务中心',
          gzdz:'甘肃省庆阳市西峰区育才东路北，汇景家园西门向南100米（原汇景家园客服中心）',
          cclx:[
            {
              tel: '0934-8610315'
            }
          ],
          wz: [35.728377,107.661226],
          slyw: '入网开户、锁闭报停、锁闭复供、面积变更、更名过户、刷卡及扫码缴费（不受理现金缴费）、电子发票、政策咨询'
        },
        {
          Address:'新区客户服务中心',
          gzdz:'甘肃省庆阳市西峰区安化西路与长庆大道交叉口西南50米，百花祥苑北门附近（原百花祥苑客服中心）',
          cclx:[
            {
              tel: '0934-8610316'
            }
          ],
          wz: [35.709888,107.634826],
          slyw: '入网开户、锁闭报停、锁闭复供、面积变更、更名过户、刷卡及扫码缴费（不受理现金缴费）、电子发票、政策咨询'
        },
        {
          Address:'庆阳市政务服务中心',
          gzdz:'甘肃省庆阳市西峰区安化西路3号人防大厦，A105  A106窗口。',
          slyw: '入网开户、锁闭报停、锁闭复供、面积变更、更名过户、刷卡及扫码缴费（不受理现金缴费）、电子发票、故障报修、政策咨询',
          cclx: [],
          wz: [35.710693,107.642737],
        },
      ]
    }
  },
  created() {
    const companyCode = sessionStorage.getItem('companyCode')?sessionStorage.getItem('companyCode'):getQueryVariable("state")
    weixinInit(companyCode);
    if(!sessionStorage.getItem('theFlag')) {
      sessionStorage.setItem('theFlag',1)
      window.location.reload()
    }
  },
  methods:{
    adres(item){
      wx.ready(()=>{
        wx.openLocation({
          latitude: item.wz[0], // 纬度，浮点数，范围为90 ~ -90
          longitude:item.wz[1], // 经度，浮点数，范围为180 ~ -180。
          name: item.Address, // 位置名
          address: item.gzdz, // 地址详情说明
          scale: 18, // 地图缩放级别,整型值,范围从1~28。默认为最大
        });
      })
    }
  }
}
</script>

<style scoped>
.fwwd{
  padding: 10px;
  height: 90%;
  overflow-y: auto;
  font-size: 14px;
  /*font-weight: bold;*/
}
.lineWord{
  padding: 8px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f1f1;
}
.text_blue{
  color: #0074FF;
}
.el-card{
  margin-top: 10px;
  border-radius: 4%;
}
.el-divider--horizontal{
  margin-top: 18px;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/xxcx/fuwuwangdian.vue